<template>
  <b-container label="Actualizar Datos" v-if="selectedHolidayObject">
    <b-row>
      <b-col>
        <b-form-group label="Capacidad AM" class="mb-2">
          <b-form-input
            disabled
            number
            v-model="selectedHolidayObject.morningDisponibility"
          />
        </b-form-group>
        <b-form-group label="Tipo Vigencia" class="mb-1">
          <b-form-select
            disabled
            :options="validityTypeOptions"
            v-model="selectedHolidayObject.isAllDay"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Capacidad PM" class="mb-1">
          <b-form-input
            disabled
            number
            type="number"
            v-model="selectedHolidayObject.eveningDisponibility"
          />
        </b-form-group>
        <b-form-group label="Descripción" class="mb-1">
          <b-form-input
            disabled
            v-model="selectedHolidayObject.description"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Inicio" class="mb-1">
          <b-form-select
            disabled
            :options="hourOptions"
            v-model="selectedHolidayObject.initialTime"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Almuerzo" class="mb-1">
          <b-form-select
            disabled
            :options="hourOptions"
            v-model="selectedHolidayObject.lunchTime"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Cierre" class="mb-1">
          <b-form-select
            disabled
            :options="hourOptions"
            v-model="selectedHolidayObject.finalTime"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Fecha inicio">
          <b-form-datepicker
            disabled
            v-model="selectedHolidayObject.initialDate"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Fecha término">
          <b-form-datepicker
            disabled
            v-model="selectedHolidayObject.finalDate"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Sucursales" class="mb-1 scrollable">
          <ul>
            <li
              v-for="location in selectedHolidayObject.location"
              :key="'location_' + location.id"
            >
              {{ location.name }}
            </li>
          </ul>
          <!-- <b-form-select
            disabled
            multiple
            :options="options"
            v-model="selectedLocations"
            :select-size="5"
          ></b-form-select> -->
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
 .scrollable {
  max-height: 200px;
  overflow-y: auto;
 }

 .scrollable ul {
  padding: 0;
  margin: 0;
 }

 .scrollable li {
  padding: 5px 10px;
 }
</style>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BCardBody,
  BFormSelect,
  BFormGroup,
  BRow,
  BCol,
  BContainer,
  BFormInput,
  BFormCheckbox,
  BFormDatepicker,
} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'

export default {
  components: {
    BCardBody,
    BFormSelect,
    VueElementLoading,
    BFormGroup,
    BRow,
    BCol,
    BContainer,
    BFormInput,
    BFormCheckbox,
    BFormDatepicker,
    DatePicker,
  },
  data() {
    return {
      selectedHolidayObject: null,
      selectedLocations: [],
      initialDate: null,
      finalDate: null,
      options: [],
      hourOptions: [
        { value: '07:00', text: '07:00' },
        { value: '08:00', text: '08:00' },
        { value: '09:00', text: '09:00' },
        { value: '10:00', text: '10:00' },
        { value: '11:00', text: '11:00' },
        { value: '12:00', text: '12:00' },
        { value: '13:00', text: '13:00' },
        { value: '14:00', text: '14:00' },
        { value: '15:00', text: '15:00' },
        { value: '16:00', text: '16:00' },
        { value: '17:00', text: '17:00' },
        { value: '18:00', text: '18:00' },
        { value: '19:00', text: '19:00' },
        { value: '20:00', text: '20:00' },
        { value: '21:00', text: '21:00' },
      ],
      validityTypeOptions: [
        { value: null, text: 'Seleccione...' },
        { value: 'true', text: 'Completa' },
        { value: 'false', text: 'Parcial' },
      ],
      answers: [],
      dateRange: [],
    }
  },
  watch: {
    selectedHolidayObject: {
      handler(newValue) {
        this.setHolidayForm(newValue)
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('holidays', ['selectedHoliday']),
  },
  methods: {
    ...mapActions('holidays', ['getHolidayById']),
    ...mapActions('locations', ['getLocations']),
    ...mapMutations('holidays', ['setHolidayForm']),
    selectLocations(event) {
      // this.$store.respuesta_store[data.pregunta.pregunta] = this.selected;
      /*       this.answers.forEach((item) => {
        this.answers.push(item.value)
      }) */
    },
    prepareData() {
      if (this.selectedHoliday) {
        this.selectedLocations = this.selectedHoliday.location.map(
          (item) => item.id
        )
        const { finalDate, initialDate, isAllDay } = this.selectedHoliday
        this.selectedHolidayObject = this.selectedHoliday
        this.finalDate = finalDate
        this.initialDate = initialDate
      }
    },
    setLocationOptions(locations) {
      this.options = locations.map((location) => {
        return {
          value: location.id,
          text: location.name,
        }
      })
    },
  },
  async created() {
    /*this.getLocations()
      .then((result) => {
        console.log(result)
        this.setLocationOptions(result.data.items)
      })
      .finally(async () => {*/
        await this.getHolidayById()
        await this.prepareData()
      //})
  },
}
</script>
